export const linearDefaultCoords = {
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 0,
};

export const radialDefaultCoords = {
  ...linearDefaultCoords,
  r1: 0,
  r2: 0,
};
